import React from 'react';
import { motion } from 'framer-motion';
import { Zap, FlaskConical, Atom, Zap as Electron, Beaker, Leaf, Trophy } from 'lucide-react';
const volumes = [{
  year: '1°',
  color: 'bg-blue-500'
}, {
  year: '2°',
  color: 'bg-green-500'
}, {
  year: '3°',
  color: 'bg-orange-500'
}, {
  year: '4°',
  color: 'bg-purple-500'
}, {
  year: '5°',
  color: 'bg-slate-500'
}];
const details = [{
  title: 'CUADERNILLO 1 — FUNDAMENTOS DE QUÍMICA Y SISTEMAS MATERIALES',
  desc: 'Materia, propiedades, estados de agregación, modelo de partículas y transformaciones físicas y químicas.',
  icon: <FlaskConical className="text-blue-600" data-id="element-181" data-mp="3fefa0yzwr5ea" />
}, {
  title: 'CUADERNILLO 2 — ESTRUCTURA ATÓMICA Y TABLA PERIÓDICA',
  desc: 'Modelos atómicos, partículas subatómicas, número atómico, número másico, isótopos, iones, tabla periódica y propiedades periódicas.',
  icon: <Atom className="text-green-600" data-id="element-182" data-mp="1l0wfzz5364xq" />
}, {
  title: 'CUADERNILLO 3 — CONFIGURACIÓN ELECTRÓNICA Y ENLACES QUÍMICOS',
  desc: 'Distribución electrónica, bloques de la tabla periódica, enlaces iónicos, covalentes y metálicos, y estructuras de Lewis.',
  icon: <Electron className="text-orange-600" data-id="element-183" data-mp="3o4j2lu57zbbf" />
}, {
  title: 'CUADERNILLO 4 — QUÍMICA INORGÁNICA Y REACCIONES',
  desc: 'Números de oxidación, formulación, nomenclatura, compuestos inorgánicos, reacciones químicas, balanceo y estequiometría.',
  icon: <Beaker className="text-purple-600" data-id="element-184" data-mp="1r2f45dkhykv" />
}, {
  title: 'CUADERNILLO 5 — QUÍMICA ORGÁNICA, SALUD Y AMBIENTE',
  desc: 'Carbono, hidrocarburos, grupos funcionales, polímeros, bioquímica básica, salud y química ambiental.',
  icon: <Leaf className="text-slate-600" data-id="element-185" data-mp="fpiuekphwxem" />
}];
export function ProductBreakdown() {
  return <section className="py-6 md:py-12 px-4 max-w-4xl mx-auto" data-id="element-186" data-mp="fno9h6e855aj">
      <div className="text-center mb-6 md:mb-10" data-id="element-187" data-mp="knaonldm4vlz">
        <div className="inline-flex items-center gap-2 text-blue-600 font-black tracking-widest text-sm uppercase mb-4" data-id="element-188" data-mp="2hgvpki1nvqxh">
          <Zap size={18} className="fill-blue-600" data-id="element-189" data-mp="2mf6wol0knnc0" />
          <span data-id="element-190" data-mp="2mi2wkevzcm33">Química Visual</span>
        </div>
        <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-6 leading-tight" data-id="element-191" data-mp="2eehg0lfgpdkv">
          MEGAPACK QUÍMICA VISUAL™ EDICIÓN LATAM
        </h2>
        <p className="text-slate-600 font-bold text-sm md:text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-192" data-mp="29iafj85u4uab">
          5 cuadernillos organizados por niveles. +600 páginas con teoría clara,
          actividades secuenciadas, rúbricas, experiencias de laboratorio y
          proyectos integradores.
        </p>
      </div>

      <div className="grid grid-cols-5 gap-2 md:gap-4 mb-8 md:mb-12" data-id="element-193" data-mp="2sf1x9d5qb1c9">
        {volumes.map((v, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.05
      }} className={`${v.color} aspect-[3/4] rounded-lg md:rounded-xl flex flex-col items-center justify-center text-white shadow-lg relative overflow-hidden group`} data-id="element-194" data-mp="373yeo0todqpj" data-mpi={i}>
            <span className={`font-black ${v.isSpecial ? 'text-[10px] md:text-xs' : 'text-xl md:text-2xl'}`} data-id="element-195" data-mp="3c180z7lrpm95">
              {v.year}
            </span>
            {v.isSpecial && <Trophy size={14} className="mt-1" data-id="element-196" data-mp="3jqsoaxjptab" />}
          </motion.div>)}
      </div>

      <div className="space-y-4" data-id="element-197" data-mp="3lplq8xltbmws">
        {details.map((item, i) => <motion.div key={i} initial={{
        opacity: 0,
        x: -10
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-white p-5 md:p-6 rounded-2xl border border-blue-50 shadow-sm flex gap-4 items-start" data-id="element-198" data-mp="3qpq6cmit6fmh" data-mpi={i}>
            <div className="bg-slate-50 p-3 rounded-xl shrink-0" data-id="element-199" data-mp="330ynilr3z9md">
              {item.icon}
            </div>
            <div data-id="element-200" data-mp="372sicdemhjem">
              <h4 className="font-black text-slate-900 text-sm md:text-lg mb-1 leading-tight" data-id="element-201" data-mp="372abkmuc3msg">
                {item.title}
              </h4>
              <p className="text-slate-600 text-xs md:text-base leading-relaxed font-medium" data-id="element-202" data-mp="2y0t1pm7ishc7">
                {item.desc}
              </p>
            </div>
          </motion.div>)}

        {/* Block A */}
        <motion.div initial={{
        opacity: 0,
        x: -10
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="bg-white p-5 md:p-6 rounded-2xl border border-blue-50 shadow-sm flex gap-4 items-start" data-id="element-203" data-mp="7rdopbidstp">
          <div className="bg-slate-50 p-3 rounded-xl shrink-0" data-id="element-204" data-mp="3ho969tboaul0">
            <Zap className="text-blue-600" data-id="element-205" data-mp="3hlmqx7ijjas8" />
          </div>
          <div data-id="element-206" data-mp="3co4l3pztlbog">
            <h4 className="font-black text-slate-900 text-sm md:text-lg mb-2 leading-tight" data-id="element-207" data-mp="3cnl5wh1k11e4">
              NUEVO: BIBLIOTECA QUÍMICA VISUAL™
            </h4>
            <p className="text-slate-600 text-xs md:text-base leading-relaxed font-medium mb-3" data-id="element-208" data-mp="33ozt72irkgl9">
              Más de 150 fichas ilustradas con explicaciones breves, esquemas,
              ejemplos y recursos visuales para facilitar la comprensión de los
              contenidos más importantes de química.
            </p>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 text-slate-600 text-xs md:text-sm font-medium mb-3" data-id="element-209" data-mp="19fuknwoq7atw">
              <li className="flex items-center gap-1.5" data-id="element-210" data-mp="1eddzaxpc5pmd">
                <span className="text-blue-600" data-id="element-211" data-mp="1j78fhr5qfmgp">✓</span> Materia y sistemas
                materiales
              </li>
              <li className="flex items-center gap-1.5" data-id="element-212" data-mp="1o4qrjqf1qhsx">
                <span className="text-blue-600" data-id="element-213" data-mp="qi1i4vi0l2x1">✓</span> Estructura atómica
              </li>
              <li className="flex items-center gap-1.5" data-id="element-214" data-mp="vgcqf1snv5d5">
                <span className="text-blue-600" data-id="element-215" data-mp="vguv8mte2rwo">✓</span> Tabla periódica
              </li>
              <li className="flex items-center gap-1.5" data-id="element-216" data-mp="10e4ka1cv91jz">
                <span className="text-blue-600" data-id="element-217" data-mp="14hss8l5etz5r">✓</span> Enlaces químicos
              </li>
              <li className="flex items-center gap-1.5" data-id="element-218" data-mp="2bv4j7ftpyemz">
                <span className="text-blue-600" data-id="element-219" data-mp="2bul3m5rjk2c4">✓</span> Números de oxidación
              </li>
              <li className="flex items-center gap-1.5" data-id="element-220" data-mp="2fumtzirtt9c3">
                <span className="text-blue-600" data-id="element-221" data-mp="gqwt2fc1afgk">✓</span> Compuestos inorgánicos
              </li>
              <li className="flex items-center gap-1.5" data-id="element-222" data-mp="bt4syy18jn1a">
                <span className="text-blue-600" data-id="element-223" data-mp="bupkees96pux">✓</span> Reacciones químicas y
                balanceo
              </li>
              <li className="flex items-center gap-1.5" data-id="element-224" data-mp="kt9vatrknv8l">
                <span className="text-blue-600" data-id="element-225" data-mp="ktt7ruygdrf8">✓</span> Estequiometría
              </li>
              <li className="flex items-center gap-1.5" data-id="element-226" data-mp="3t9w9zl6sqnw6">
                <span className="text-blue-600" data-id="element-227" data-mp="3p7rm73314lhg">✓</span> Soluciones
              </li>
              <li className="flex items-center gap-1.5" data-id="element-228" data-mp="6tibgcedjkmo">
                <span className="text-blue-600" data-id="element-229" data-mp="6v38c8o5vfnp">✓</span> Ácidos, bases y pH
              </li>
              <li className="flex items-center gap-1.5" data-id="element-230" data-mp="220dlx7ne05x">
                <span className="text-blue-600" data-id="element-231" data-mp="3aibzby6md071">✓</span> Química orgánica
              </li>
            </ul>
            <p className="text-slate-600 text-xs md:text-base leading-relaxed font-medium" data-id="element-232" data-mp="35k211eplljh7">
              El material se entrega en documentos completos y también en fichas
              individuales para que cada docente pueda imprimir o compartir
              únicamente lo que necesita.
            </p>
          </div>
        </motion.div>

        {/* Block B */}
        <motion.div initial={{
        opacity: 0,
        x: -10
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="bg-white p-5 md:p-6 rounded-2xl border border-blue-50 shadow-sm flex gap-4 items-start" data-id="element-233" data-mp="1byyptgn3jdom">
          <div className="bg-slate-50 p-3 rounded-xl shrink-0" data-id="element-234" data-mp="1ur9oeyapwpgx">
            <Trophy className="text-blue-600" data-id="element-235" data-mp="1ur1bj6elhk5q" />
          </div>
          <div data-id="element-236" data-mp="1zpky9910izz5">
            <h4 className="font-black text-slate-900 text-sm md:text-lg mb-2 leading-tight" data-id="element-237" data-mp="1zp2s9kojt7e1">
              MÁS DE 200 ACTIVIDADES LISTAS PARA UTILIZAR
            </h4>
            <p className="text-slate-600 text-xs md:text-base leading-relaxed font-medium mb-3" data-id="element-238" data-mp="obqmv5d54gpr">
              Incluye ejercicios de completamiento, clasificación, formulación,
              nomenclatura, interpretación, resolución de cálculos, desafíos
              integradores y actividades de reflexión. Muchas actividades
              incluyen formatos A y B para trabajar el mismo contenido mediante
              consignas diferentes.
            </p>
            <p className="text-slate-600 text-xs md:text-sm font-bold mb-2" data-id="element-239" data-mp="113m5p6lf46nr">
              Esto permite:
            </p>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 text-slate-600 text-xs md:text-sm font-medium" data-id="element-240" data-mp="1tq6sdtqy7ukz">
              <li className="flex items-center gap-1.5" data-id="element-241" data-mp="1oyyjqzxg0d8v">
                <span className="text-blue-600" data-id="element-242" data-mp="1oxdp7ab4oub0">✓</span> Trabajar con diferentes
                grupos
              </li>
              <li className="flex items-center gap-1.5" data-id="element-243" data-mp="2hfrdai6nx1ww">
                <span className="text-blue-600" data-id="element-244" data-mp="2hhca6egg8wxx">✓</span> Reducir la copia de
                respuestas
              </li>
              <li className="flex items-center gap-1.5" data-id="element-245" data-mp="2cmyba22kw7oi">
                <span className="text-blue-600" data-id="element-246" data-mp="2kyqkl9uhyucd">✓</span> Utilizar una versión
                para práctica y otra para evaluación
              </li>
              <li className="flex items-center gap-1.5" data-id="element-247" data-mp="2p13nlqhv0e5g">
                <span className="text-blue-600" data-id="element-248" data-mp="2txlp8hhw7wdk">✓</span> Observar diferentes
                procedimientos
              </li>
              <li className="flex items-center gap-1.5" data-id="element-249" data-mp="2yyrl2o6unzrb">
                <span className="text-blue-600" data-id="element-250" data-mp="33xckilea2fep">✓</span> Realizar recuperaciones
              </li>
              <li className="flex items-center gap-1.5" data-id="element-251" data-mp="37xcxe1lqaijn">
                <span className="text-blue-600" data-id="element-252" data-mp="37vs56imvzboy">✓</span> Adaptar las actividades
                según cada estudiante
              </li>
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}